/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPIHousien } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export interface CreateSubscriptionInput {
  plan_id: string;
  agency_id: string;
  redirect_url: string;
}

export interface CreateSubscriptionResponse {
  checkout_url?: string;
  payment_url?: string; // Fallback para compatibilidade
  subscription_id?: string;
  temp_token?: string;
  [key: string]: any;
}

/** Whether the owner still has the free period, as the backend answers it. */
export interface TrialEligibility {
  trial_eligible: boolean;
  trial_used_at: string | null;
}

/**
 * SubscriptionService class.
 */
export class SubscriptionService {
  /**
   * Create a new subscription
   * Creates a subscription and returns a payment URL
   * @param requestBody
   * @returns CreateSubscriptionResponse Subscription created successfully with payment URL
   * @throws ApiError
   */
  public static createSubscription(
    requestBody: CreateSubscriptionInput
  ): CancelablePromise<CreateSubscriptionResponse> {
    return __request(OpenAPIHousien, {
      method: 'POST',
      url: '/subscriptions/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Whether the free period still applies to the owner (first subscription only).
   * Without `agencyId` it answers for the signed-in user (onboarding, before the
   * agency exists); with it, for that agency's owner (needs `manage_agency`).
   * @param agencyId optional agency to answer for
   * @returns TrialEligibility The owner's eligibility
   * @throws ApiError
   */
  public static getTrialEligibility(
    agencyId?: string
  ): CancelablePromise<TrialEligibility> {
    return __request(OpenAPIHousien, {
      method: 'GET',
      url: '/subscriptions/trial-eligibility',
      query: agencyId ? { agency_id: agencyId } : undefined,
    });
  }
}
